import { URL_PATH_DRILLDOWN_EXPLORATION_VIEWER } from 'features/drilldown'

import { SelectedTab } from './types'

export const getSelectedTab = (pathname: string): SelectedTab | undefined => {
  if (pathname.includes('/home')) return SelectedTab.Home
  if (pathname.includes('/assets')) return SelectedTab.Assets
  if (pathname.includes('/ships')) return SelectedTab.Ships
  if (pathname.includes('/inspections')) return SelectedTab.Inspections
  if (pathname.includes('/inspection-dashboard')) return SelectedTab.Inbox
  if (pathname.includes('publisher')) return SelectedTab.Publisher
  if (pathname.includes('/health-plans')) return SelectedTab.HealthPlans
  if (pathname.includes('/budgeting')) return SelectedTab.Budgeting
  if (pathname.includes('/scheduling')) return SelectedTab.InspectionScheduling
  if (pathname.includes('/availability-planning'))
    return SelectedTab.AvailabilityPlanning
  if (pathname.includes(`/overview`)) return SelectedTab.Overview
  if (pathname.includes('/cases')) return SelectedTab.Cases
  if (pathname.includes(URL_PATH_DRILLDOWN_EXPLORATION_VIEWER))
    return SelectedTab.Exploration
  if (pathname.includes('/explorer')) return SelectedTab.Explorer
  if (pathname.includes('/prism')) return SelectedTab.Prism
  if (pathname.includes('/parts')) return SelectedTab.PartsThread
  if (pathname.includes('/jobs')) return SelectedTab.JobsOverview
  if (pathname.includes('/walkdowns')) return SelectedTab.Walkdowns
  if (pathname.includes('/reporting')) return SelectedTab.Reporting
  if (pathname.includes('/inventory')) return SelectedTab.InventoryManagement
  if (pathname.includes('/maximo')) return SelectedTab.Maximo
  if (pathname.includes('/system-lens')) return SelectedTab.SystemLens
  if (pathname.includes('/point-cloud')) return SelectedTab.PointCloud
  if (pathname.includes('/process-flows'))
    return SelectedTab.ProcessFlowDiagrams
  if (pathname.includes('/value-stories')) return SelectedTab.ValueStories
  if (pathname.includes('/process-data')) return SelectedTab.ProcessData
  // The 3D model viewer is opened from the Assets page and stays under it.
  if (pathname.includes('/walkthrough')) return SelectedTab.Assets
  if (pathname.includes('/anomaly-detection'))
    return SelectedTab.AnomalyDetection
  if (pathname.includes('/documents/cmms')) return SelectedTab.CmmsExplorer
  if (pathname.includes('/documents')) return SelectedTab.Documents
  if (pathname.includes('/loto-reports')) return SelectedTab.LotoReports
  if (pathname.includes('/fimmetrics')) return SelectedTab.FimMetrics
  if (pathname.includes('/libra')) return SelectedTab.Libra
  if (pathname.includes('/nii-dashboard')) return SelectedTab.NiiDashboard
  if (pathname.includes('/production-dashboard'))
    return SelectedTab.ProductionDashboard
  if (pathname.includes('/virtual-reports')) return SelectedTab.VirtualReports
  if (pathname.includes('/notifications')) return SelectedTab.Notifications
  if (pathname.includes('/pipeline-fleet')) return SelectedTab.PipelineFleet
  if (pathname.includes('/pipelines')) return SelectedTab.Pipelines
  if (pathname.includes('/site-context-monitoring'))
    return SelectedTab.SiteContextMonitoring
  if (pathname.includes('/facility-model')) return SelectedTab.FacilityModel
  if (pathname.includes('/model-operations')) return SelectedTab.ModelOperations
  if (pathname.includes('/weldmap')) return SelectedTab.WeldMap
  if (pathname.includes('/logbook')) return SelectedTab.Logbook
  if (pathname.includes('/alerts')) return SelectedTab.Alerts
  if (pathname.includes('/entry-browser')) return SelectedTab.EntryBrowser
  if (pathname.includes('/nnpp/acceptance-review'))
    return SelectedTab.NnppReports
  if (pathname.includes('/nnpp/orders')) return SelectedTab.NnppOrders
  if (pathname.includes('/nnpp/reports')) return SelectedTab.NnppReports
  if (pathname.includes('/nnpp/imports')) return SelectedTab.NnppImports
  if (pathname.includes('/nnpp/components')) return SelectedTab.NnppComponents
}
